import { LocalizedDate } from '@/components/Atoms/LocalizedDate/LocalizedDate';
import { Notification } from '@/components/Atoms/Notification/Notification';
import useTranslation from '@/hooks/useTranslation';
import Trans from 'next-translate/Trans';
import { memo } from 'react';

export const TrialBanner = memo(({ expireDate }: IProps) => {
    const { t } = useTranslation('common');
    const now = new Date();
    const msPerDay = 1000 * 60 * 60 * 24;
    const daysLeft = Math.ceil((expireDate.getTime() - now.getTime()) / msPerDay);

    let trialMessage = (
        <Trans
            i18nKey="common:Navigation.TrialBanner.expires_future"
            components={{
                date: (
                    <strong>
                        <LocalizedDate date={expireDate.toISOString()} />
                    </strong>
                ),
            }}
        />
    );
    if (daysLeft <= 1) {
        trialMessage = (
            <Trans i18nKey="common:Navigation.TrialBanner.expires_today" components={{ strong: <strong /> }} />
        );
    } else if (daysLeft > 1 && daysLeft < 30) {
        trialMessage = t('common:Navigation.TrialBanner.expires_this_month', { count: daysLeft });
    }

    return (
        <Notification fullWidth state="information" id="trial-banner">
            {trialMessage}
        </Notification>
    );
});

interface IProps {
    expireDate?: Date;
}
